<ng-select
  [disabled]="disabled"
  [items]="option$ | async"
  [bindLabel]="bindLable"
  [bindValue]="bindValue"
  [name]="name"
  [(ngModel)]="innerValue"
  [multiple]="multiple"
  [trackByFn]="trackByFn"
  [loading]="!(option$ | async)"
  [typeToSearchText]="searchText"
  [placeholder]="placeHolder"
  [typeahead]="searchInput$"
  (change)="valueChanged($event)"
>
</ng-select>
